import useCompanionAccess from '../hooks/useCompanionAccess';
import { MenuList, ThemeProvider } from '@mui/joy';
import MenuItem from '@mui/joy/MenuItem';
import { createTheme, ListItemText } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { pictos } from '../assets/img/pictos';
import { PoliceDefaut } from '../helpers/contants';
import {
  maJourneeRedux,
  partenairesRedux,
  participantsRedux,
  programmesRedux,
} from '../redux/evenementsServices';
import { setParticipantsCache } from '../redux/evenementsSlice';
import { contactsRedux, demandesRedux, invitationsRedux } from '../redux/profilService';
import textConnect from '../textConnect.json';
import ErrorPopup from './ErrorPopup';

const DashboardMenu = props => {
  const { isCompanion, requireAccount } = useCompanionAccess();
  const userToken = useSelector(state => state.user.access);
  const evenementSelected = useSelector(state => state.evenements.evenementSelect);
  const participantsCache = useSelector(state => state.evenements.participantsCache);
  const dispatch = useDispatch();
  const navigationPage = useNavigate();

  const theme = createTheme({
    typography: {
      fontFamily: PoliceDefaut,
      fontSize: 13,
    },
  });

  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, [netStatus]);

  const partenaires = (token, id) => {
    partenairesRedux(token, id)
      .then(reponse => {
        dispatch({
          type: 'evenements/addExposant',
          payload: reponse.data,
        });
        navigationPage('/partenaires');
        window.scrollTo(0, 0);
      })
      .catch(erreur => {
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };
  const maJournee = (token, id) => {
    if (requireAccount('Ma journée')) return;
    maJourneeRedux(token, id)
      .then(reponse => {
        dispatch({
          type: 'evenements/addMajournee',
          payload: reponse.data,
        });
        console.log('Get ma Journée :', reponse);
        navigationPage('/majournee');
        window.scrollTo(0, 0);
      })
      .catch(erreur => {
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };
  const participantsList = (token, id) => {
    const cached = participantsCache?.[id];
    if (cached) {
      dispatch({ type: 'evenements/addParticipants', payload: cached });
      navigationPage('/participants');
      window.scrollTo(0, 0);
      if (isCompanion) return;
      contactsRedux(userToken).then(reponse => {
        dispatch({ type: 'Profil/addContacts', payload: reponse.data });
        demandesRedux(userToken).then(reponse => {
          dispatch({ type: 'Profil/addDemandes', payload: reponse.data });
        });
        invitationsRedux(userToken).then(reponse => {
          dispatch({ type: 'Profil/addInvitations', payload: reponse.data });
        });
      });
      return;
    }
    participantsRedux(token, id)
      .then(reponse => {
        dispatch({ type: 'evenements/addParticipants', payload: reponse.data });
        dispatch(setParticipantsCache({ eventId: id, data: reponse.data }));
        navigationPage('/participants');
        window.scrollTo(0, 0);
        if (isCompanion) return;
        contactsRedux(userToken).then(reponse => {
          dispatch({
            type: 'Profil/addContacts',
            payload: reponse.data,
          });

          demandesRedux(userToken).then(reponse => {
            // console.log(reponse.data)

            dispatch({
              type: 'Profil/addDemandes',
              payload: reponse.data,
            });
          });

          invitationsRedux(userToken).then(reponse => {
            // console.log(reponse.data)

            dispatch({
              type: 'Profil/addInvitations',
              payload: reponse.data,
            });
          });

          // navigationPage('/contacts')
        });
      })
      .catch(erreur => {
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };

  const mesProgrammes = (token, idEvent) => {
    programmesRedux(token, idEvent)
      .then(async response => {
        dispatch({
          type: 'evenements/addProgramme',
          payload: response.data,
        });
        navigationPage('/programmes');
        window.scrollTo(0, 0);
      })
      .catch(erreur => {
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };

  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');

  const closeErrorHandle = () => {
    setOpenError(false);
  };

  return (
    <>
      <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />
      <ThemeProvider theme={theme}>
        <Container fluid className="d-flex justify-content-end">
          <MenuList
            className="menu-dashboard1"
            aria-labelledby="btn-dashboard"
            sx={{
              zIndex: 1000,
              right: 0,
              borderRadius: '20px 0 0 20px',
              top: '18%',
              position: 'fixed',
              '--List-padding': '12px 8px',
              '--ListItem-paddingY': '6px',
              '--ListItem-paddingX': '16px',
              minWidth: 260,
              display: props.open !== 'false' && props.menuOpen !== false ? 'flex' : 'none',
            }}
            variant="plain"
          >
            <MenuItem
              selected={props.selected === 1}
              className=""
              style={{ height: 'fit-content', borderRadius: '20px 0 0 20px' }}
              onClick={() => participantsList(userToken, evenementSelected.id)}
            >
              <ListItemText className="texte" style={{ width: '20px' }}>
                <div
                  className="d-flex align-items-center"
                  style={{ color: '#134491', fontFamily: PoliceDefaut }}
                >
                  Participants
                </div>
              </ListItemText>
              <img
                className=""
                src={pictos.participant_icone}
                alt=""
                style={{
                  borderRadius: '50%',
                  backgroundColor: '#f2552c',
                  width: '16%',
                }}
              />
            </MenuItem>
            <MenuItem
              selected={props.selected === 2}
              className=""
              style={{
                height: 'fit-content',
                fontFamily: PoliceDefaut,
                borderRadius: '20px 0 0 20px',
              }}
              onClick={() => partenaires(userToken, evenementSelected.id)}
            >
              <ListItemText className="texte" style={{ width: '20px' }}>
                <div
                  className="d-flex align-items-center"
                  style={{ color: '#134491', fontFamily: PoliceDefaut }}
                >
                  Exposants
                </div>
              </ListItemText>
              <img
                className=""
                src={pictos.partenaires_icone}
                alt=""
                style={{
                  borderRadius: '50%',
                  backgroundColor: '#1ba9e4',
                  width: '16%',
                }}
              />
            </MenuItem>
            <MenuItem
              selected={props.selected === 3}
              className=""
              style={{
                height: 'fit-content',
                fontFamily: PoliceDefaut,
                borderRadius: '20px 0 0 20px',
              }}
              onClick={() => {
                if (!requireAccount('Mes rendez-vous')) navigationPage('/mes-rendez-vous');
              }}
            >
              <ListItemText className="texte" style={{ width: '20px' }}>
                <div
                  className="d-flex align-items-center"
                  style={{ color: '#134491', fontFamily: PoliceDefaut }}
                >
                  {'Mes rendez-vous'}
                </div>
              </ListItemText>
              <img
                className=""
                src={pictos.mes_rendez_vous_icone}
                alt=""
                style={{
                  borderRadius: '50%',
                  backgroundColor: '#2a93e8',
                  width: '16%',
                }}
              />
            </MenuItem>
            <MenuItem
              selected={props.selected === 4}
              className=""
              style={{
                height: 'fit-content',
                fontFamily: PoliceDefaut,
                borderRadius: '20px 0 0 20px',
              }}
              onClick={() => maJournee(userToken, evenementSelected.id)}
            >
              <ListItemText className="texte" style={{ width: '20px' }}>
                <div
                  className="d-flex align-items-center"
                  style={{ color: '#134491', fontFamily: PoliceDefaut }}
                >
                  Ma journée
                </div>
              </ListItemText>
              <img
                className=""
                src={pictos.journee_icone}
                alt=""
                style={{
                  borderRadius: '50%',
                  backgroundColor: '#f8ad42',
                  width: '16%',
                }}
              />
            </MenuItem>
            <MenuItem
              selected={props.selected === 5}
              className=""
              style={{
                height: 'fit-content',
                fontFamily: PoliceDefaut,
                borderRadius: '20px 0 0 20px',
              }}
              onClick={() => mesProgrammes(userToken, evenementSelected.id)}
            >
              <ListItemText className="texte" style={{ width: '20px' }}>
                <div
                  className="d-flex align-items-center"
                  style={{ color: '#134491', fontFamily: PoliceDefaut }}
                >
                  Programme
                </div>
              </ListItemText>
              <img
                className=""
                src={pictos.programme_icone}
                alt=""
                style={{
                  borderRadius: '50%',
                  backgroundColor: '#d3183a',
                  width: '16%',
                }}
              />
            </MenuItem>
            <MenuItem
              selected={props.selected === 6}
              className=""
              style={{
                height: 'fit-content',
                fontFamily: PoliceDefaut,
                borderRadius: '20px 0 0 20px',
              }}
              onClick={() => navigationPage('/planStand/0')}
            >
              <ListItemText className="texte" style={{ width: '20px' }}>
                <div
                  className="d-flex align-items-center"
                  style={{ color: '#134491', fontFamily: PoliceDefaut }}
                >
                  {'Plan des stands'}
                </div>
              </ListItemText>
              <img
                className=""
                src={pictos.plan_stand_icone}
                alt=""
                style={{
                  borderRadius: '50%',
                  backgroundColor: '#b7d8f5',
                  width: '16%',
                }}
              />
            </MenuItem>
          </MenuList>
        </Container>
      </ThemeProvider>
    </>
  );
};

export default DashboardMenu;
